/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { LabDrawViewModel } from './LabDrawViewModel'; 

export function getLabDrawsByOrderOptions(orderId: string, onSuccess?: (result: LabDrawViewModel[]) => void) {
	return queryOptions({
		queryKey: ['lab-draws-by-order', orderId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/frequencies/queries/getlabdrawsbyorder/' + orderId;
			const resp = await axios.get<LabDrawViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(orderId)
	});
}